import React, {useContext, useEffect, useState} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  achievementSection
} from "../../portfolio";

function Header() {
  const [currentSection, setCurrentSection] = useState("greeting");
  const {isDark, changeTheme} = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;

  useEffect(() => {
    const sectionIds = ["greeting", "skills", "experience", "achievements", "contact"];

    const handleIntersect = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setCurrentSection(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, {
      root: null,
      threshold: 0.3
    });

    sectionIds.forEach(id => {
      const el = document.getElementById(id);
      if (el) {
        observer.observe(el);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {viewSkills && (
            <li>
              <a
                href="#skills"
                className={currentSection === "skills" ? "active" : undefined}
              >
                What I do
              </a>
            </li>
          )}
          {viewExperience && (
            <li>
              <a
                href="#experience"
                className={currentSection === "experience" ? "active" : undefined}
              >
                Work Experiences
              </a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a
                href="#achievements"
                className={
                  currentSection === "achievements" ? "active" : undefined
                }
              >
                Achievements
              </a>
            </li>
          )}
          <li>
            <a
              href="#contact"
              className={currentSection === "contact" ? "active" : undefined}
            >
              Contact Me
            </a>
          </li>
          <li>
            <button
              type="button"
              className="theme-toggle-button"
              onClick={changeTheme}
              aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
            >
              <ToggleSwitch />
            </button>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
